// extracted by mini-css-extract-plugin
export default {"imageWrapper":"bK-z","twoColumnImage":"cK-z"};